import { toTitleCase } from "Utils";
import { ChartColorCodes } from "./CommonData";

const FraudIncidentStatus = {
    PENDING: "PENDING",
    RESOLVED: "RESOLVED",
    ALL: "ALL",
};

const FraudIncidentStatusVariant = {
    [FraudIncidentStatus.PENDING]: "warning",
    [FraudIncidentStatus.RESOLVED]: "success",
};

const FraudRulesStatusMap = {
    ENABLED: {
        status: "ENABLED",
        text: "Enable",
        color: "success",
        textColor: "text-success",
        buttonColor: "outline-success",
    },
    DISABLED: {
        status: "DISABLED",
        text: "Disable",
        color: "warning",
        textColor: "text-warning",
        buttonColor: "outline-warning",
    },
};

const FraudMainTabs = {
    FRAUD_OVERVIEW: "fraudOverview",
    FRAUD_INCIDENTS: "fraudIncidents",
    FRAUD_AUTO_SUSPENDED_MEMBERS: "fraudAutoSuspendedMembers",
    FRAUD_RULES: "fraudRules",
};

const FraudActivityTrendsLineChartColorCodes = {
    FRAUD_INCIDENTS: ChartColorCodes.BLUE,
    AUTO_SUSPENSIONS: ChartColorCodes.RED,
};

const RuleBreachDistributionPieChartColorCodes = [
    ChartColorCodes.BLUE,
    ChartColorCodes.RED,
    ChartColorCodes.GREEN,
    ChartColorCodes.ORANGE,
    ChartColorCodes.PURPLE,
];

const ResolvedIncidentsTrackingChartColorCodes = {
    AUTO_SUSPENDED_RESOLVED: ChartColorCodes.GREEN,
    MANUALLY_RESOLVED: ChartColorCodes.BLUE,
};

const FraudIncidentStatusOptions = Object.values(FraudIncidentStatus).map(
    (item) => {
        let label = toTitleCase(item);

        if (item === FraudIncidentStatus.ALL) label = "All Cases";
        else if (item === FraudIncidentStatus.PENDING) label = "Pending Review";

        return { key: item, label };
    }
);

const FraudSummaryTooltips = {
    totalIncidents: "Total number of fraud-related incidents, including both flagged and automatically suspended cases",
    autoResolved: "The count of incidents that were automatically suspended the members",
    pendingIncidents: "The number of fraud incidents that are currently unresolved",
    memberAutoSuspended: "The number of members who have been automatically suspended due to violations detected by fraud rules.",
};

export {
    FraudIncidentStatus,
    FraudRulesStatusMap,
    FraudMainTabs,
    FraudIncidentStatusVariant,
    FraudActivityTrendsLineChartColorCodes,
    RuleBreachDistributionPieChartColorCodes,
    ResolvedIncidentsTrackingChartColorCodes,
    FraudIncidentStatusOptions,
    FraudSummaryTooltips,
};
